// Owner admin key: kept only in this tab's sessionStorage and sent on write requests.
const STORAGE_KEY = 'taiboku-admin-key';
const listeners = new Set();
let pending = null;

export const getAdminKey = () => sessionStorage.getItem(STORAGE_KEY);
export const clearAdminKey = () => sessionStorage.removeItem(STORAGE_KEY);

export const onAdminKeyRequest = (fn) => {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
};

const requestAdminKey = () => {
  if (!pending) {
    pending = new Promise((resolve) => listeners.forEach((fn) => fn(resolve)))
      .then((key) => {
        if (key) sessionStorage.setItem(STORAGE_KEY, key);
        return key;
      })
      .finally(() => { pending = null; });
  }
  return pending;
};

const isWrite = (cfg) => !['get', 'head', 'options'].includes((cfg.method || 'get').toLowerCase());

export const attachAdminKey = (client) => {
  client.interceptors.request.use((cfg) => {
    const key = getAdminKey();
    if (key && isWrite(cfg)) cfg.headers['X-Admin-Key'] = key;
    return cfg;
  });
  client.interceptors.response.use(null, async (err) => {
    const cfg = err.config;
    if (err.response?.status !== 401 || !cfg || !isWrite(cfg)) throw err;
    clearAdminKey();
    if (cfg._adminRetry) throw err;
    const key = await requestAdminKey();
    if (!key) {
      err.response.data = { ...(err.response.data || {}), detail: 'Admin key required' };
      throw err;
    }
    cfg._adminRetry = true;
    return client(cfg);
  });
};
